import '/app/brewery-packages/content/content-editor-plugin-link/src/Link.css-raw';
export default {
  "link": "news-4a753f38-link-d8xOKa"
};